import { BinRangeResponse } from 'src/models/binRange.models'
import { RootState } from 'src/redux/createRootReducer'
import { ErrorDetailMap } from 'src/utils/error.utils'

export const selectCountrysFetchedFromState = (state: RootState): boolean =>
  state.app.registerAccount.countrysFetched
export const selectCountrysFailedFromState = (state: RootState): boolean =>
  state.app.registerAccount.countrysFailed
export const selectIssuersFetchedFromState = (state: RootState): boolean =>
  state.app.registerAccount.issuersFetched
export const selectIssuersFailedFromState = (state: RootState): boolean =>
  state.app.registerAccount.issuersFailed
export const selectPostingCreditCardFromState = (state: RootState): boolean =>
  state.app.registerAccount.postingCreditCard
export const selectFetchingIssuerFromState = (state: RootState): boolean =>
  state.app.registerAccount.fetchingIssuer
export const selectTopLevelErrorFromState = (
  state: RootState,
): string | undefined => state.app.registerAccount.topLevelError
export const selectErrorDetailMapFromState = (
  state: RootState,
): ErrorDetailMap<string> | undefined =>
  state.app.registerAccount.errorDetailMap
export const selectBinRangeInfoFromState = (
  state: RootState,
): BinRangeResponse | undefined => state.app.registerAccount.binRangeInfo
export const selectIssuerIdFromState = (state: RootState): string | undefined =>
  state.app.registerAccount.binRangeInfo?.issuerId?.trim()
